import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from '@/api';
import PushAdvertisementEdit from '../edit/index';
import PushMessageUser from '../../pushMessageUser/edit/index';
import MemberComment from '../../components/comment/index';
export default {
  name: 'PushAdvertisementList',
  components: {
    PushAdvertisementEdit: PushAdvertisementEdit,
    PushMessageUser: PushMessageUser,
    MemberComment: MemberComment
  },
  data: function data() {
    return {
      memberCommentVisible: false,
      isOptionUser: this.checkauthority('adv_option_user'),
      pushUserEditDisabled: false,
      pushUserDialogVisible: false,
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      isSelect: this.checkauthority('advertisement_select'),
      isCreate: this.checkauthority('advertisement_add'),
      isUpdate: this.checkauthority('advertisement_edit'),
      isDelete: this.checkauthority('advertisement_del'),
      isMemberComment: this.checkauthority('advertisement_member_comment_select'),
      selectForm: {
        createTimes: []
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      educations: [],
      sex: [],
      marriages: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  methods: {
    memberCommentClose: function memberCommentClose() {
      this.memberCommentVisible = false;
    },
    selectComont: function selectComont(index, data) {
      this.memberCommentVisible = true;
      this.$refs.memberComment.setTitle('评论内容');
      this.$refs.memberComment.initTableData(6, data.advId);
    },
    getEnumValue: function getEnumValue(enums, value) {
      for (var index in enums) {
        var item = enums[index];
        if (value === item.values) {
          return item.keys;
        }
      }
      return '';
    },
    getMarriagesEnumList: function getMarriagesEnumList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: 'mbmber_marriage_select'
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.marriages = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getSexEnumList: function getSexEnumList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: 'member_sex'
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this2.sex = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getEducationsEnumList: function getEducationsEnumList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                name: 'mbmber_education_select'
              };
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context3.v;
              _this3.educations = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    groupStr: function groupStr(data) {
      var str = '性别:' + this.getEnumValue(this.sex, data.sex) + '  最小年龄:' + data.minAge + '  最大年龄:' + data.maxAge + '  婚姻:' + this.getEnumValue(this.marriages, data.marriage) + '  学历:' + this.getEnumValue(this.educations, data.education);
      return str;
    },
    pushUserClose: function pushUserClose() {
      this.pushUserDialogVisible = false;
    },
    openPushUser: function openPushUser() {
      this.pushUserEditDisabled = false;
      this.pushUserDialogVisible = true;
      this.$refs.pushUser.setTitle('设置消息账号');
      this.$refs.pushUser.initData(2);
    },
    getImagesImage: function getImagesImage(row) {
      var url = JSON.parse(row.images)[0].url;
      return this.downloadUrl + url;
    },
    getImagesImages: function getImagesImages(row) {
      var _this4 = this;
      var images = JSON.parse(row.images);
      var urls = [];
      images.forEach(function (img) {
        urls.push(_this4.downloadUrl + img.url);
      });
      return urls;
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                name: name
              };
              _context4.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context4.v;
              _this5.enumList = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this6 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.daleteApi(index, data);
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                advId: data.advId
              };
              _context5.n = 1;
              return api.DELETE_PUSHADVERTISEMENT(par);
            case 1:
              _this7.initTableData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return api.DELETE_BATCH_PUSHADVERTISEMENT(par);
            case 1:
              _this8.$message.success('操作成功');
              _this8.initTableData();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this9 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this9.tableSelects.forEach(function (element) {
          par.push(element.advId);
        });
        _this9.deleteBatchApi(par);
      }).catch(function () {
        _this9.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.createTimes = [];
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var par, res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              par = {
                pageNo: _this0.pageNo,
                pageSize: _this0.pageSize
              };
              if (_this0.selectForm.createTimes.length > 1) {
                par.startCreateTime = _this0.selectForm.createTimes[0];
                par.endCreateTime = _this0.selectForm.createTimes[1];
              }
              _context7.n = 1;
              return api.GET_PUSHADVERTISEMENT_PAGE_LIST(par);
            case 1:
              res = _context7.v;
              _this0.tableData = res.body.datas;
              _this0.pageTotal = res.body.sumDataCount;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.getMarriagesEnumList();
    this.getEducationsEnumList();
    this.getSexEnumList();
    this.initTableData();
  }
};